export abstract class BaseFaxMedicalRequestComposite {
    public Id: string;
    public PatientId: string;
    public PdfFileName: string;

    constructor(id?: string, patientId?: string, fileName?: string) {
        this.Id = id || "";
        this.PatientId = patientId || "";
        this.PdfFileName = fileName || "";
    }
}
